if (!customElements.get('card-atc-button')) {
  customElements.define(
    'card-atc-button',
    class CardAtcButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorMessage = this.querySelector('.card-atc__error');
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      async onClick(event) {
        event.preventDefault();
        if (this.button.classList.contains('loading')) return;

        this.setLoading(true);
        this.setError();

        const config = fetchConfig();
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          items: [{ id: Number(this.dataset.variantId), quantity: Number(this.dataset.quantity) || 1 }],
        });

        try {
          const response = await fetch(`${routes.cart_add_url}.js`, config);
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(data.description || data.message);

          await this.openCart();
        } catch (error) {
          this.setError(error.message || window.cartStrings?.error);
        } finally {
          this.setLoading(false);
        }
      }

      // UpCart public API: https://aftersell.mintlify.app/upcart/common_upcart_api_uses
      async openCart() {
        if (typeof window.upcartOpenCart !== 'function') {
          window.location.href = routes.cart_url;
          return;
        }
        await window.upcartRefreshCart?.();
        window.upcartOpenCart();
      }

      setLoading(isLoading) {
        this.button.classList.toggle('loading', isLoading);
        this.button.setAttribute('aria-busy', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
      }

      setError(message) {
        this.errorMessage.textContent = message || '';
        this.errorMessage.hidden = !message;
      }
    }
  );
}
